// extracted by mini-css-extract-plugin
module.exports = {"organisationAvatar":"Avatar_organisationAvatar__AjjQ_"};